/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport } from '../helper/get-json-export.helper';
import { Locale } from '../model/locale.model';

import * as formats from '../format/core-de.format.json';
import * as texts from '../text/core-de.text.json';

export const coreDeLocale: Locale = {
  texts: getJsonExport(texts),
  formats: getJsonExport(formats)
};
